// extracted by mini-css-extract-plugin
export default {"button":"y0kvNY","pricingOptionsHeader":"Qzyv7D"};